<template>
  <el-upload ref="loadControl" class="upload" :class="{'iconUpload': info.icon}" action="#" :auto-upload="false" :on-change="handleChange" :on-remove="handleRemove" :file-list="fileList" :multiple="info.multiple" :accept="info.fileType">
    <i class="iconfont icon-export" v-if="info.icon"></i>
    <el-button v-else type="success">{{ $t('lang.upload') }}</el-button>
  </el-upload>
</template>

<script>
import AWS from 'aws-sdk'
import Bus from '@/assets/js/vueBus.js'
import { mapState } from 'vuex'
import toTips from '@/assets/js/toTipsObj'
export default {
  props: {
    info: {
      type: Object,
      default () {
        return {}
      }
    }
  },
  data () {
    return {
      fileList: [],
      uploadObj: {},
      uploadParams: {},
      fileNum: 0,
      uploadingFile: null,
      awsInfo: {
        bucket: '',
        region: ''
      },
      region: '',
      // 拥有者session
      userSessionId: ''
    }
  },
  computed: mapState({
    State: (state) => state
  }),
  created () {
    // const awsInfo = {
    //   bucket: this.State.common.baseUrl.awsRegionalInfo.bucket,
    //   region: this.State.common.baseUrl.awsRegionalInfo.region
    // }
    // this.awsInfo = Object.assign({}, awsInfo)
    // this.region = this.$store.state.region ? this.$store.state.region : this.awsInfo.region
  },
  methods: {
    stopUpload () {
      const item = this.fileList.filter((v) => v.status == 'uploading' || v.status == 'prepar')
      if (item.length === 0) {
        this.fileList = []
        return
      }
      this.$confirm(this.$t('lang.uploadNoCompleted'), this.$t('lang.cancelUpload'), {
        confirmButtonText: this.$t('lang.cancelToUpload'),
        cancelButtonText: this.$t('lang.continueToUpload'),
        cancelButtonClass: 'btn-custom-cancel',
        confirmButtonClass: 'btn-custom-confirm',
        center: true
      }).then(() => {
        this.$refs.loadControl.abort()
        item.forEach((obj) => {
          this.uploadObj[obj.uid].abort()
        })
        this.fileList = []
        this.uploadObj = {}
        this.uploadParams = {}
        this.uploadingFile = null
        this.fileNum = 0
      })
    },
    handleChange (file) {
      this.uploadingFile = file
      this.uploadingFile.progress = 0
      this.uploadingFile.status = 'prepar'
      this.fileNum += 1
      this.fileList.push(this.uploadingFile)
      // this.getVideoTime()
      this.uploadFileBySDK()
    },
    async queryParentId () {
      const param = {
        userId: localStorage.getItem('userId'),
        programId: this.$BehaviorSyns.getProgramId()
      }
      await this.axios.post('/gatewayPlayoutUrl/tvu-playout/playoutfolderNew/queryParentId', param).then((res) => {
        if (res.data.errorCode == '0x0') {
          this.userSessionId = res.data.result.session
        } else {
          const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
          this.$message.info(errorInfo)
        }
      }).catch()
    },
    async uploadFileBySDK () {
      const params = {
        region: this.region, // 选中的region
        service: 'pp',
        directoryName: this.info.folderName,
        fileName: this.uploadingFile.name
      }
      await this.queryParentId()
      this.$http.post('/file/request-upload-for-sdk', params, { requestBase: 'GATEWAY', sessionRoleId: this.userSessionId }
      ).then((res) => {
        if (res.data.errorCode == '0x0') {
          const { result } = res.data
          this.uploadParams[this.uploadingFile.uid] = result
          AWS.config.region = result.identityPoolRegion
          AWS.config.credentials = new AWS.CognitoIdentityCredentials({
            IdentityPoolId: result.identityPoolId
          })
          this.doUploadFile(this.uploadingFile)
        }
      })
    },
    doUploadFile (obj) {
      this.uploadObj[obj.uid] = new AWS.S3.ManagedUpload({
        params: {
          Bucket: this.uploadParams[obj.uid].bucket,
          Key: this.uploadParams[obj.uid].objectKey,
          Body: obj.raw,
          ACL: 'public-read' // 固定
        },
        service: new AWS.S3({
          region: this.uploadParams[obj.uid].region
        })
      })
      this.uploadObj[obj.uid].on('httpUploadProgress', (event) => {
        const item = this.fileList.filter((v) => v.uid === obj.uid)
        var index = this.fileList.findIndex((v) => v.uid === obj.uid)
        item[0].progress = Math.floor(event.loaded * 100 / event.total)
        item[0].status = 'uploading'
        if (item[0].progress == 100) {
          item[0].progress = 99
        }
        this.$set(this.fileList, index, item[0])
      })
      this.uploadObj[obj.uid].promise().then((data) => {
        const item = this.fileList.filter((v) => v.uid === obj.uid)
        var index = this.fileList.findIndex((v) => v.uid === obj.uid)
        this.saveResult(item[0], index)
      })
    },
    saveResult (item, index) {
      // console.log(this.uploadParams[item.uid])
      const params = {
        bucketId: this.uploadParams[item.uid].bucketId,
        directoryId: this.uploadParams[item.uid].directoryId,
        isDirectory: false,
        objectKey: this.uploadParams[item.uid].objectKey
      }
      this.$http.post('/file/add-file', params, { requestBase: 'GATEWAY' }
      ).then((res) => {
        if (res.data.errorCode == '0x0') {
          if (this.fileNum > 0) {
            this.fileNum -= 1
          }
          this.uploadParams[item.uid].fileId = res.data.result
          this.saveFile(item, index)
        }
      }).catch()
    },
    saveFile (item, index) {
      let params = {}
      Object.keys(this.uploadParams).forEach((key) => {
        params = {
          nickName: this.uploadParams[key].fileName,
          name: this.uploadParams[key].fileName,
          fileId: this.uploadParams[key].fileId,
          videoUrls: '',
          fileType: this.info.type,
          sessionId: localStorage.getItem('channelSession')
        }
      })
      const url = '/gatewayPlayoutUrl/tvu-playout/fileInfoNew/add'
      this.axios.post(url, params, { contentType: 'application/json;charset=UTF-8' })
        .then((res) => {
          if (res.data.errorCode == '0x0') {
            item.progress = 100
            item.status = 'success'
            this.$set(this.fileList, index, item)
            Bus.$emit('refreshFileList', 'mcp')
            if (this.info.tag) {
              this.$refs.loadControl.clearFiles()
            }
          } else {
            const errorInfo = this.$t(toTips[res.data.errorCode]) || res.data.errorInfo
            this.$message.info(errorInfo)
            item.status = 'failed'
            this.$set(this.fileList, index, item)
          }
        }).catch()
    },
    handleRemove (file, fileList) {
      this.fileList = fileList
    },
    handlePreview (file) {
      console.log(file)
    }
  },
  filters: {
    uploadingText (num) {
      let str = ''
      if (num == 0) {
        str = 'Upload to complete'
        return str
      }
      if (num == 1) {
        str = 'Uploading 1 file'
        return str
      }
      if (num > 1) {
        str = `Uploading ${num} files`
        return str
      }
    }
  },
  beforeDestroy () {
    Bus.$off('refreshFileList')
  }
}
</script>
<style lang="less" scoped>
.upload {
  width: 100%;
  float: left;
  .el-upload {
    text-align: left;
    .el-upload-list__item-name {
      color: #dfdfdf;
    }
  }
}
::deep .el-progress--circle {
  float: right;
  margin: 5px 10px;
  .el-progress-circle {
    height: 30px !important;
    width: 30px !important;
  }
  .el-progress__text {
    font-size: 10px !important;
  }
}
</style>
